<template>
    <div class="kit-order-form">
        <div class="kit-order-form-section" v-for="(section, section_index) in sections">

            <div class="kit-header p-10">
                <label>{{ supply.supply_desc }}</label>
                <div class="form-inline" v-if="supply.kit.sampleTypes">
                    <span class="m-r-5">Sample Type:</span>
                    <span v-if="supply.kit.sampleTypes.length == 1" class="text-bold">{{ supply.kit.sampleTypes[0].sample_type_label }}</span>
                    <span v-else-if="multipleSampleTypes">
                        <select class="form-control" v-model="section.sampleType">
                            <option value=""></option>
                            <option v-for="sampleType in supply.kit.sampleTypes"
                                    class="form-control"
                                    :value="sampleType.sample_type_nbr"
                            >
                                {{ sampleType.sample_type_label }}
                            </option>
                        </select>
                    </span>
                </div>
            </div>

            <div class="kit-body" v-show="section.sampleType">
                <div class="row">
                    <div class="col-xs-12 table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th><span class="text-bold">Sample ID</span> -
                                        Please include a descriptive name for the sample that you are sending to Midwest Laboratories. This name is for your identification and will show up on result reports. (Examples: Lower Bathroom Sink, Batch 223, Front Lawn - North Side)
                                    </th>
                                    <th v-for="field in supply.kit.fields">
                                        {{ field.field_label }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(sample, sample_index) in section.samples">
                                    <td>
                                        <span class="m-r-5" v-if="multipleSampleTypes" v-show="section.samples.length > 1">
                                            <button type="button" class="btn btn-danger btn-circle-xs" @click="removeSample(section_index,sample_index)">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </span>
                                        <span class="m-r-5" v-show="!sample.id || sample.fields.filter(field => !field.value).length > 0">
                                            <button type="button" class="btn btn-warning btn-circle-xs"
                                                data-toggle="popover" data-trigger="hover" data-placement="right"
                                                data-title="Missing Required Fields" data-content="All fields are required"
                                            >
                                                <i class="fa fa-info"></i>
                                            </button>
                                        </span>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control focus-border" v-model="sample.id" @change="updateKitAnalysisOrder" />
                                    </td>
                                    <td v-for="field in sample.fields">
                                        <input type="text" class="form-control focus-border" v-model="field.value" @change="updateKitAnalysisOrder" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="row p-10" v-if="multipleSampleTypes && supply.supply_qty > 1">
                    <div class="col-xs-6">
                        <button type="button" class="btn btn-success" @click="addSample(section_index)" :disabled="totalSamples == supply.supply_qty">
                            <i class="fa fa-plus"></i>
                            ADD SAMPLE
                        </button>
                    </div>
                    <div class="col-xs-6 text-right">
                        <button type="button" class="btn btn-default" @click="addSection" :disabled="totalSamples >= supply.supply_qty">
                            <i class="fa fa-plus"></i>
                            ADD GROUP
                        </button>
                        <button type="button" class="btn btn-danger" @click="removeSection(section_index)" :disabled="sections.length < 2">
                            <i class="fa fa-trash"></i>
                            REMOVE GROUP
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import '../../sass/_global_variables.scss';

    .kit-order-form {
        .kit-header {
            background-color: #ebf2f8;
        }

        .kit-body {
            background-color: #ffffff;

            table {
                thead {
                    th {
                        background-color: $gray-blue;
                        color: #ffffff;

                        &:first-child {
                            width: 100px;
                        }
                    }
                }

                tbody {
                    td {
                        &:first-child {
                            width: 100px;
                        }

                        input {
                            max-width: 250px;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            supply: { default: {} },
            supply_order_id: { default: null }
        },

        data: function() {
            return {
                sections: [],
                loaded: false
            }
        },

        computed: {
            multipleSampleTypes() {
                return this.supply.kit.sampleTypes.length > 1;
            },

            totalSamples() {
                var samples = 0;
                this.sections.forEach(section => { samples += section.samples.length });
                return samples;
            },

            requiredTests() {
                return this.supply.kit.analyses.map(test => {
                    return test.analysis_nbr;
                }).join(',');
            },

            complete() {
                return (this.totalSamples != this.supply.supply_qty) ? false : this.sections.filter(section =>
                    !section.sampleType || section.samples.filter(sample =>
                        !sample.id || sample.fields.filter(field => !field.value).length > 0
                    ).length > 0
                ).length == 0;
            }
        },

        watch: {
            sections: {
                deep: true,
                handler() {
                    this.$emit('update_order',{
                        complete: this.complete,
                        sections: this.sections
                    });
                }
            },

            complete() {
                this.$emit('check_status');
            }
        },

        methods: {
            addSection() {
                if (this.totalSamples == this.supply.supply_qty) return;
                else if (this.totalSamples > this.supply.supply_qty) this.sections = [];

                if (this.sections.length == 0 || this.multipleSampleTypes) {
                    var sampleType = '';
                    if (this.supply.kit && this.supply.kit.sampleTypes && this.supply.kit.sampleTypes.length == 1) {
                        sampleType = this.supply.kit.sampleTypes[0].sample_type_nbr;
                    }
                    this.sections.push({sampleType, samples: []});
                }
                for(var i=this.totalSamples;i<this.supply.supply_qty;i++) {
                    this.addSample(this.sections.length - 1,false);
                }

                this.updateKitAnalysisOrder();
            },

            removeSection(section_index) {
                if (this.sections.length < 2) return;
                this.sections.splice(section_index,1);
                this.updateKitAnalysisOrder();
            },

            addSample(section_index,saveToDB=true) {
                if (!this.sections[section_index]) return;
                var sample = { id: '', tests: this.requiredTests, fields: [] };
                this.supply.kit.fields.forEach(field => {
                    sample.fields.push({ number: field.field_nbr, value: "" });
                });
                this.sections[section_index].samples.push(sample);

                if (saveToDB) this.updateKitAnalysisOrder();
            },

            removeSample(section_index,sample_index) {
                if (!this.sections[section_index] || !this.sections[section_index].samples[sample_index]) return;
                this.sections[section_index].samples.splice(sample_index,1);

                this.updateKitAnalysisOrder();
            },

            updateKitAnalysisOrder() {
                this.$emit('update_kit');
            }
        },

        mounted() {
            this.addSection();
            $(document).ready(function() {
                $('[data-toggle="popover"]').popover();
            })
        }
    }
</script>



// WEBPACK FOOTER //
// supply-kit-analysis-order.vue?4d8d2608